import { graphql, Link } from "gatsby";
import React from "react";
import PostMeta from "../components/draftbox-meta/PostMeta";
import { DraftboxPost } from "../models/draftbox-post-description.model";
import htmlParser from "html-react-parser";
import Helmet from "react-helmet";

type PostTemplateAmpProps = {
  data: {
    draftboxPost: DraftboxPost & { ampHead: string[]; ampMarkup: string };
    draftboxSettings: {
      identity: {
        siteName: string;
        siteUrl: string;
      };
    };
  };
  pageContext: any;
};

const PostTemplateAmp: React.FC<PostTemplateAmpProps> = ({
  data,
  pageContext,
}) => {
  const { draftboxPost, draftboxSettings } = data;
  let pathname = "";

  try {
    pathname =
      new URL(draftboxSettings.identity.siteUrl).pathname === "/"
        ? ""
        : new URL(draftboxSettings.identity.siteUrl).pathname;
  } catch (error) {}

  return (
    <>
      <PostMeta amp={true} post={draftboxPost} />
      <Helmet htmlAttributes={{ amp: "" }}>
        {htmlParser(draftboxPost.ampHead.join(""))}
      </Helmet>
      <div>
        <header className="main-header">
          <nav className="blog-name">
            <Link
              to="/"
              dangerouslySetInnerHTML={{
                __html: draftboxSettings.identity.siteName,
              }}
            ></Link>
          </nav>
        </header>
        <main className="content prose prose-lg" role="main">
          <article className="post tag-getting-started">
            <header className="post-header">
              <h1
                className="post-title"
                dangerouslySetInnerHTML={{ __html: draftboxPost.title }}
              ></h1>
              <div className="post-meta">
                <div className="post-meta-avatars">
                  <p className="author">{draftboxPost.primaryAuthor.name}</p>
                </div>
                <time
                  className="post-date"
                  dateTime="{{date format='DD-MM-YYYY'}}"
                >
                  {draftboxPost.updatedAt}
                </time>{" "}
              </div>
            </header>
            {draftboxPost?.featureImage?.childImageSharp && (
              <figure className="post-image">
                {/* 
@ts-ignore */}
                <amp-img
                  layout="responsive"
                  height={
                    draftboxPost.featureImage?.childImageSharp?.gatsbyImageData
                      ?.height || 0
                  }
                  width={
                    draftboxPost.featureImage?.childImageSharp?.gatsbyImageData
                      ?.width || 0
                  }
                  src={draftboxPost.featureImage.publicURL}
                  alt={draftboxPost.title}
                >
                  {/* 
// @ts-ignore */}
                </amp-img>
              </figure>
            )}
            {!draftboxPost?.featureImage?.childImageSharp &&
              draftboxPost?.featureImage?.publicURL && (
                <figure className="post-image post-image-fill">
                  {/* 
@ts-ignore */}
                  <amp-img
                    layout="fill"
                    src={draftboxPost?.featureImage?.publicURL}
                    alt={draftboxPost.title}
                    height={
                      draftboxPost.featureImage?.childImageSharp
                        ?.gatsbyImageData?.height || 0
                    }
                  >
                    {/* 
// @ts-ignore */}
                  </amp-img>
                </figure>
              )}
            {draftboxPost.ampMarkup && (
              <section
                className="post-content"
                dangerouslySetInnerHTML={{
                  __html: draftboxPost.ampMarkup,
                }}
              ></section>
            )}
            {draftboxPost.primaryTag && (
              <div className="tags">
                <span id="tag-label">Tag:</span>
                <a
                  className="tag"
                  href={`${pathname}/tag/${draftboxPost.primaryTag.slug}`}
                >
                  {draftboxPost.primaryTag.name}
                </a>
              </div>
            )}

            <div className="comment-button-container">
              <button>
                <a href={`${pathname}/${draftboxPost.postSeoSlug}`}>
                  View original article
                </a>
              </button>
            </div>
          </article>
        </main>
      </div>
    </>
  );
};

export const PostTemplateAmpQuery = graphql`
  query($postSeoSlug: String!) {
    draftboxPost(postSeoSlug: { eq: $postSeoSlug }) {
      ...DraftboxPostDetails
    }

    draftboxSettings {
      identity {
        siteName
        siteUrl
      }
    }
  }
`;

export default PostTemplateAmp;
